import '../pages/css/Spinner.css';


export default function Spinner() {
    return (
        <div className="spinner-wrapper">
            <div className="spinner" />
            <span className="spinner-text">Cargando...</span>              
        </div>
    );
}



